
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5af7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5af7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lA1wN", function(module, exports) {

$parcel$export(module.exports, "initHeaderActiveNav", function () { return $fb5e25347d6b7784$export$9a4306cb330df17c; });
$parcel$export(module.exports, "initHeaderCTA", function () { return $fb5e25347d6b7784$export$439db37d80004144; });
// assets/js/layout/header.js
function $fb5e25347d6b7784$export$9a4306cb330df17c() {
    const page = document.body.dataset.page;
    if (!page) return;
    document.querySelectorAll('.top-bar__nav-pill a, .top-bar__nav-panel a').forEach((link)=>{
        if (link.dataset.nav === page) link.classList.add('is-active');
    });
}
function $fb5e25347d6b7784$export$439db37d80004144() {
    const cta = document.querySelector('[data-header-cta]');
    if (!cta) return;
    const page = document.body.dataset.page;
    switch(page){
        case 'inicio':
        case 'cuestionarios':
            cta.innerHTML = `
				<a class="btn btn-primary" href="app.html#register">Reg\xedstrate gratis</a>
			`;
            break;
        case 'planes':
            cta.innerHTML = `
				<a class="btn btn-primary" href="app.html#register">Reg\xedstrate gratis</a>
			`;
            break;
        case 'info':
            cta.innerHTML = `
				<a class="btn btn-primary" href="app.html#register">Reg\xedstrate gratis</a>
			`;
            break;
        case 'app':
            cta.innerHTML = `
				<!-- \u{1F510} AUTH BAR (renderizada por AuthHeaderController + AuthHeaderView) -->
				<div class="auth-bar" data-auth-header></div>
			`;
            break;
        default:
            cta.innerHTML = `
				<a class="btn btn-primary" href="app.html">[...to be configured]</a>
			`;
    }
}

});

// src/assets/js/pages/info/main.js

var $lA1wN = parcelRequire("lA1wN");
document.addEventListener('DOMContentLoaded', async ()=>{
    (0, $lA1wN.initHeaderActiveNav)();
    (0, $lA1wN.initHeaderCTA)();
    // Hydrate About (version / release notes / license)
    await $0fa7217081bc3846$var$hydrateAbout(document);
    // Deep-link inicial
    if (location.hash) $0fa7217081bc3846$var$highlightSectionFromHash(location.hash);
    // Cambios de hash sin recargar (footer / navegación interna)
    window.addEventListener('hashchange', ()=>{
        $0fa7217081bc3846$var$highlightSectionFromHash(location.hash);
    });
});
function $0fa7217081bc3846$var$highlightSectionFromHash(hash) {
    const id = String(hash || '').replace('#', '').trim();
    if (!id) return;
    const el = document.getElementById(id);
    if (!el) return;
    // scroll suave hacia la sección
    el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
    // resaltar la card contenedora
    const card = el.closest('.panel-card') || el.closest('.plan-card') || el;
    // limpiar anteriores
    document.querySelectorAll('.is-highlighted').forEach((n)=>n.classList.remove('is-highlighted'));
    // aplicar
    card.classList.add('is-highlighted');
    // quitar tras unos segundos
    window.clearTimeout(card.__highlightTimeoutId);
    card.__highlightTimeoutId = window.setTimeout(()=>{
        card.classList.remove('is-highlighted');
    }, 4200);
}
async function $0fa7217081bc3846$var$hydrateAbout(bodyEl) {
    const root = bodyEl.querySelector('[data-page="legal-about"]');
    if (!root) return;
    const set = (key, value)=>{
        const el = root.querySelector(`[data-about="${key}"]`);
        if (el) el.textContent = value ?? "\u2014";
    };
    // helpers para cargar textos (release notes / license)
    const setPre = (key, text, { emptyFallback: emptyFallback = 'No disponible' } = {})=>{
        const el = root.querySelector(`[data-about="${key}"]`);
        if (!el) return;
        const t = (text ?? '').trim();
        el.textContent = t || emptyFallback;
    };
    let v = null;
    let s = {};
    // 1) version.json (puede no existir en dev)
    const versionDetailsEl = root.querySelector('[data-about="versionDetails"]');
    try {
        const res = await fetch('/version.json', {
            cache: 'no-store'
        });
        if (res.ok) {
            v = await res.json();
            set('name', v.name || 'SelectivIA');
            set('version', v.version || "\u2014");
            s = v.selectivia || {};
            set('tag', s.tag || "\u2014");
            set('channel', s.channel || "\u2014");
            set('codename', s.codename || "\u2014");
            set('buildTimestamp', s.buildTimestamp || "\u2014");
            const commit = s.gitCommit ? String(s.gitCommit).slice(0, 12) : "\u2014";
            set('gitCommit', commit);
            // ✅ Importante: este <pre> SOLO muestra estado / mensaje.
            // Si todo va bien, lo ocultamos.
            if (versionDetailsEl) {
                versionDetailsEl.style.display = 'none';
                versionDetailsEl.textContent = '';
            }
        } else {
            console.warn('[about] version.json not found (dev mode?)');
            if (versionDetailsEl) {
                versionDetailsEl.style.display = 'inline-flex';
                versionDetailsEl.textContent = "Informaci\xf3n de versi\xf3n no disponible";
            }
        }
    } catch (err) {
        console.warn('[about] version.json not available:', err);
        if (versionDetailsEl) {
            versionDetailsEl.style.display = 'inline-flex';
            versionDetailsEl.textContent = "Informaci\xf3n de versi\xf3n no disponible";
        }
    }
    // 2) Resto de campos (siempre visibles, pero si no existen en HTML no pasa nada)
    set('project', s.project || v?.project || "\u2014");
    set('environment', s.environment || v?.environment || "\u2014");
    // 3) Release notes y licencia (los copias a prod con copy:prod)
    //    - RELEASE_NOTES.md -> /RELEASE_NOTES.md
    //    - LICENSE.md -> /LICENSE.md
    try {
        const [notesRes, licenseRes] = await Promise.all([
            fetch('/RELEASE_NOTES.md', {
                cache: 'no-store'
            }),
            fetch('/LICENSE.md', {
                cache: 'no-store'
            })
        ]);
        if (notesRes.ok) {
            const notes = await notesRes.text();
            setPre('releaseNotesContent', notes, {
                emptyFallback: 'Release notes no disponibles'
            });
        } else setPre('releaseNotesContent', '', {
            emptyFallback: 'Release notes no disponibles'
        });
        if (licenseRes.ok) {
            const license = await licenseRes.text();
            setPre('licenseContent', license, {
                emptyFallback: 'Licencia no disponible'
            });
        } else setPre('licenseContent', '', {
            emptyFallback: 'Licencia no disponible'
        });
    } catch (err) {
        console.warn('[about] RELEASE_NOTES / LICENSE not available:', err);
        setPre('releaseNotesContent', '', {
            emptyFallback: 'Release notes no disponibles'
        });
        setPre('licenseContent', '', {
            emptyFallback: 'Licencia no disponible'
        });
    }
}


//# sourceMappingURL=info.80112e58.js.map
